import {TableCell, TableRow, TextField} from "@mui/material";
import {DateFormat, StyledTableCell} from "../styles/MyStyles";
import {GetLookupMenuItems, GetLookupValueName} from "./LookupHelper";
import {DatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import React from "react";
import {GetEnumMenuItems, GetEnumValueName} from "./EnumHelper";
import * as MyStyles from "../styles/MyStyles";

export const GetPrivateRows = (editMode, clientDetails, handleClientDetailsChange, errors) => {
    return (
        <>
            <TableRow>
                <StyledTableCell style={{ width: '10%' }}>First Name</StyledTableCell>
                <TableCell style={{ width: '90%' }}>
                    {editMode ? (
                        <TextField
                            name="firstName"
                            label="First Name"
                            value={clientDetails.privateMetadata.firstName}
                            onChange={(e) => handleClientDetailsChange('privateMetadata.firstName', e.target.value)}
                            fullWidth
                            size='small'
                            required
                            error={!!errors.firstName}
                            helperText={errors.firstName}
                        />
                    ) : (
                        clientDetails.privateMetadata.firstName
                    )}
                </TableCell>
            </TableRow>
            <TableRow>
                <StyledTableCell style={{ width: '10%' }}>Last Name</StyledTableCell>
                <TableCell style={{ width: '90%' }}>
                    {editMode ? (
                        <TextField
                            name="lastName"
                            label="Last Name"
                            value={clientDetails.privateMetadata.lastName}
                            onChange={(e) => handleClientDetailsChange('privateMetadata.lastName', e.target.value)}
                            fullWidth
                            size='small'
                            required
                            error={!!errors.lastName}
                            helperText={errors.lastName}
                        />
                    ) : (
                        clientDetails.privateMetadata.lastName
                    )}
                </TableCell>
            </TableRow>
            <TableRow>
                <StyledTableCell style={{ width: '10%' }}>Nationality</StyledTableCell>
                <TableCell style={{ width: '90%' }}>
                    {editMode ? (
                        <TextField
                            name="nationality"
                            label="Nationality"
                            select
                            value={clientDetails.privateMetadata.nationalityId}
                            onChange={(e) => handleClientDetailsChange('privateMetadata.nationalityId', e.target.value)}
                            fullWidth
                            required
                            error={!!errors.nationalityId}
                            helperText={errors.nationalityId}
                        >
                            {GetLookupMenuItems('nationality')}
                        </TextField>
                    ) : (
                        GetLookupValueName('nationality', clientDetails.privateMetadata.nationalityId)
                    )}
                </TableCell>
            </TableRow>
            <TableRow>
                <StyledTableCell style={{ width: '10%' }}>Date Of Birth</StyledTableCell>
                <TableCell style={{ width: '90%' }}>
                    {editMode ? (
                        <DatePicker
                            timezone="UTC"
                            name="dateOfBirth"
                            label="Date Of Birth"
                            value={dayjs(clientDetails.privateMetadata.dateOfBirth)}
                            onChange={(date) => handleClientDetailsChange('privateMetadata.dateOfBirth', date.toJSON())}
                            fullWidth
                            size='small'
                            slotProps={{
                                textField: {
                                    required: true,
                                },
                            }}
                            error={!!errors.dateOfBirth}
                            helperText={errors.dateOfBirth}
                        />
                    ) : (
                        dayjs(clientDetails.privateMetadata.dateOfBirth).format(MyStyles.DateFormat)
                    )}
                </TableCell>
            </TableRow>
            <TableRow>
                <StyledTableCell style={{ width: '10%' }}>Residence Country</StyledTableCell>
                <TableCell style={{ width: '90%' }}>
                    {editMode ? (
                        <TextField
                            name="residenceCountryId"
                            label="Residence Country"
                            select
                            value={clientDetails.privateMetadata.residenceCountryId}
                            onChange={(e) => handleClientDetailsChange('privateMetadata.residenceCountryId', e.target.value)}
                            fullWidth
                            required
                            error={!!errors.residenceCountryId}
                            helperText={errors.residenceCountryId}
                        >
                            {GetLookupMenuItems('country')}
                        </TextField>
                    ) : (
                        GetLookupValueName('country', clientDetails.privateMetadata.residenceCountryId)
                    )}
                </TableCell>
            </TableRow>
            <TableRow>
                <StyledTableCell style={{ width: '10%' }}>Residence Address</StyledTableCell>
                <TableCell style={{ width: '90%' }}>
                    {editMode ? (
                        <TextField
                            name="residenceAddress"
                            label="Residence Address"
                            value={clientDetails.privateMetadata.residenceAddress}
                            onChange={(e) => handleClientDetailsChange('privateMetadata.residenceAddress', e.target.value)}
                            fullWidth
                            size='small'
                            required
                            error={!!errors.residenceAddress}
                            helperText={errors.residenceAddress}
                        />
                    ) : (
                        clientDetails.privateMetadata.residenceAddress
                    )}
                </TableCell>
            </TableRow>
            <TableRow>
                <StyledTableCell style={{ width: '10%' }}>Business Activity</StyledTableCell>
                <TableCell style={{ width: '90%' }}>
                    {editMode ? (
                        <TextField
                            name="businessActivity"
                            label="Business Activity"
                            value={clientDetails.privateMetadata.businessActivity}
                            onChange={(e) => handleClientDetailsChange('privateMetadata.businessActivity', e.target.value)}
                            fullWidth
                            size='small'
                            required
                            error={!!errors.businessActivity}
                            helperText={errors.businessActivity}
                        />
                    ) : (
                        clientDetails.privateMetadata.businessActivity
                    )}
                </TableCell>
            </TableRow>
        </>
    );
}

export const GetLegalRows = (editMode, clientDetails, handleClientDetailsChange, errors) => {
    return (
        <>
            <TableRow>
                <StyledTableCell style={{ width: '10%' }}>Name</StyledTableCell>
                <TableCell style={{ width: '90%' }}>
                    {editMode ? (
                        <TextField
                            name="name"
                            label="Name"
                            value={clientDetails.legalMetadata.name}
                            onChange={(e) => handleClientDetailsChange('legalMetadata.name', e.target.value)}
                            fullWidth
                            size='small'
                            required
                            error={!!errors.name}
                            helperText={errors.name}
                        />
                    ) : (
                        clientDetails.legalMetadata.name
                    )}
                </TableCell>
            </TableRow>
            <TableRow>
                <StyledTableCell style={{ width: '10%' }}>Registration Country</StyledTableCell>
                <TableCell style={{ width: '90%' }}>
                    {editMode ? (
                        <TextField
                            name="registrationCountryId"
                            label="Registration Country"
                            select
                            value={clientDetails.legalMetadata.registrationCountryId}
                            onChange={(e) => handleClientDetailsChange('legalMetadata.registrationCountryId', e.target.value)}
                            fullWidth
                            required
                            error={!!errors.registrationCountryId}
                            helperText={errors.registrationCountryId}
                        >
                            {GetLookupMenuItems('country')}
                        </TextField>
                    ) : (
                        GetLookupValueName('country', clientDetails.legalMetadata.registrationCountryId)
                    )}
                </TableCell>
            </TableRow>
            <TableRow>
                <StyledTableCell style={{ width: '10%' }}>Registration Address</StyledTableCell>
                <TableCell style={{ width: '90%' }}>
                    {editMode ? (
                        <TextField
                            name="registrationAddress"
                            label="Registration Address"
                            value={clientDetails.legalMetadata.registrationAddress}
                            onChange={(e) => handleClientDetailsChange('legalMetadata.registrationAddress', e.target.value)}
                            fullWidth
                            size='small'
                            required
                            error={!!errors.registrationAddress}
                            helperText={errors.registrationAddress}
                        />
                    ) : (
                        clientDetails.legalMetadata.registrationAddress
                    )}
                </TableCell>
            </TableRow>
            <TableRow>
                <StyledTableCell style={{ width: '10%' }}>Entity Type</StyledTableCell>
                <TableCell style={{ width: '90%' }}>
                    {editMode ? (
                        <TextField
                            name="entityType"
                            label="Entity Type"
                            select
                            value={clientDetails.legalMetadata.type}
                            onChange={(e) => handleClientDetailsChange('legalMetadata.type', e.target.value)}
                            fullWidth
                            required
                            error={!!errors.entityType}
                            helperText={errors.entityType}
                        >
                            {GetEnumMenuItems('entityType')}
                        </TextField>
                    ) : (
                        GetEnumValueName('entityType', clientDetails.legalMetadata.type)
                    )}
                </TableCell>
            </TableRow>
            <TableRow>
                <StyledTableCell style={{ width: '10%' }}>Business Activity</StyledTableCell>
                <TableCell style={{ width: '90%' }}>
                    {editMode ? (
                        <TextField
                            name="businessActivity"
                            label="Business Activity"
                            value={clientDetails.legalMetadata.businessActivity}
                            onChange={(e) => handleClientDetailsChange('legalMetadata.businessActivity', e.target.value)}
                            fullWidth
                            size='small'
                            required
                            error={!!errors.businessActivity}
                            helperText={errors.businessActivity}
                        />
                    ) : (
                        clientDetails.legalMetadata.businessActivity
                    )}
                </TableCell>
            </TableRow>
            <TableRow>
                <StyledTableCell style={{ width: '10%' }}>Number Of Employees</StyledTableCell>
                <TableCell style={{ width: '90%' }}>
                    {editMode ? (
                        <TextField
                            name="numberOfEmployees"
                            label="Number Of Employees"
                            select
                            value={clientDetails.legalMetadata.numberOfEmployees}
                            onChange={(e) => handleClientDetailsChange('legalMetadata.numberOfEmployees', e.target.value)}
                            fullWidth
                            required
                            error={!!errors.numberOfEmployees}
                            helperText={errors.numberOfEmployees}
                        >
                            {GetEnumMenuItems('numberOfEmployees')}
                        </TextField>
                    ) : (
                        GetEnumValueName('numberOfEmployees', clientDetails.legalMetadata.numberOfEmployees)
                    )}
                </TableCell>
            </TableRow>
            <TableRow>
                <StyledTableCell style={{ width: '10%' }}>Form</StyledTableCell>
                <TableCell style={{ width: '90%' }}>
                    {editMode ? (
                        <TextField
                            name="form"
                            label="Form"
                            select
                            value={clientDetails.legalMetadata.form}
                            onChange={(e) => handleClientDetailsChange('legalMetadata.form', e.target.value)}
                            fullWidth
                            required
                            error={!!errors.form}
                            helperText={errors.form}
                        >
                            {GetEnumMenuItems('entityForm')}
                        </TextField>
                    ) : (
                        GetEnumValueName('entityForm', clientDetails.legalMetadata.form)
                    )}
                </TableCell>
            </TableRow>
        </>
    );
}

export const ValidateForm = (clientDetails ) => {
    let newErrors = {};

    if (clientDetails.type === '') {
        newErrors.type = 'Type is required.';
    }

    if (!clientDetails.email.trim()) {
        newErrors.email = 'Email is required.';
    }

    if (clientDetails.dossierId === '') {
        newErrors.dossierId = 'Dossier Id is required.';
    }


    switch (clientDetails.type) {
        case 0:
            if (!clientDetails.privateMetadata.firstName.trim()) {
                newErrors.firstName = 'First Name is required.';
            }

            if (!clientDetails.privateMetadata.lastName.trim()) {
                newErrors.lastName = 'Last Name is required.';
            }

            if (!clientDetails.privateMetadata.residenceAddress.trim()) {
                newErrors.residenceAddress = 'Residence Address is required.';
            }

            if (!clientDetails.privateMetadata.businessActivity.trim()) {
                newErrors.businessActivity = 'Business Activity is required.';
            }

            if (clientDetails.privateMetadata.nationalityId === '') {
                newErrors.nationalityId = 'Nationality is required.';
            }

            if (clientDetails.privateMetadata.residenceCountryId === '') {
                newErrors.residenceCountryId = 'Residence Country is required.';
            }

            if (clientDetails.privateMetadata.dateOfBirth === '') {
                newErrors.dateOfBirth = 'Date Of Birth is required.';
            }
            break;
        case 1:
            if (!clientDetails.legalMetadata.name.trim()) {
                newErrors.name = 'Name is required.';
            }
            if (clientDetails.legalMetadata.registrationCountryId === '') {
                newErrors.registrationCountryId = 'Registration Country is required.';
            }
            if (!clientDetails.legalMetadata.registrationAddress.trim()) {
                newErrors.registrationAddress = 'Registration Address is required.';
            }
            if (clientDetails.legalMetadata.type === '') {
                newErrors.entityType = 'Entity Type is required.';
            }
            if (!clientDetails.legalMetadata.businessActivity.trim()) {
                newErrors.businessActivity = 'Business Activity is required.';
            }
            if (clientDetails.legalMetadata.numberOfEmployees === '') {
                newErrors.numberOfEmployees = 'Number Of Employees is required.';
            }
            if (clientDetails.legalMetadata.form === '') {
                newErrors.form = 'Form is required.';
            }
            break;
        default:
            break;
    }

    // Return the errors
    return newErrors;
};